var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{style:({ width: '100%', height: `${_vm.height}` + 'px' }),attrs:{"center":{
      lat: Number(_vm.bngLat),
      lng: Number(_vm.bngLng),
    },"zoom":7,"map-type-id":"terrain"}},[_vm._l((_vm.validStations),function(s){return _c('GmapMarker',{key:s._id,attrs:{"position":s.GPS,"clickable":true,"icon":{
        url: _vm.stationIcon(s),
        size: { width: 60, height: 48, f: 'px', b: 'px' },
        scaledSize: { width: 60, height: 48, f: 'px', b: 'px' },
      }},on:{"click":function($event){return _vm.toStatus(s)}}},[_c('GmapInfoWindow',{key:s.name,attrs:{"position":s.GPS}},[_vm._v(" "+_vm._s(s.name)+" ")]),_c('GmapCircle',{key:s._id,attrs:{"center":s.GPS,"radius":7000,"visible":true,"options":{
          strokeColor: `${_vm.colorStation(s.stage)}`,
          strokeOpacity: 0.05,
          strokeWeight: 10,
          fillColor: `${_vm.colorStation(s.stage)}`,
          fillOpacity: 0.05,
        }}})],1)}),_vm._l((_vm.validTrucks),function(t){return _c('GmapMarker',{key:t._id,attrs:{"position":{
        lat: Number(t.truck.latitude),
        lng: Number(t.truck.longitude),
      },"clickable":true,"icon":{
        url: require(`../../../public/img/icon/trucks.png`),
        size: { width: 96, height: 48, f: 'px', b: 'px' },
        scaledSize: { width: 96, height: 48, f: 'px', b: 'px' },
      }},on:{"click":function($event){return _vm.toStatus(t)}}},[_c('GmapInfoWindow',{key:t.licenseplate,attrs:{"position":{
          lat: Number(t.truck.latitude),
          lng: Number(t.truck.longitude),
        }}},[_vm._v(" "+_vm._s(t.licenseplate)+" ")]),_c('GmapCircle',{attrs:{"center":{
          lat: Number(t.truck.latitude),
          lng: Number(t.truck.longitude),
        },"radius":7000,"visible":true,"options":{
          strokeColor: '#013D81',
          strokeOpacity: 0.05,
          strokeWeight: 10,
          fillColor: '#013D81',
          fillOpacity: 0.05,
        }}})],1)})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }